import { Editor } from '@tinymce/tinymce-react';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import CRMApi from '../../../Api/CRM/CRMApi';
import ManualNotification from '../../../Api/Models/ManualNotification';
import TrueFalseIcon from '../../../components/common/TrueFalseIcon';
import ProtectedLink from '../../elements/ProtectedLink';
import Card from '../../elements/common/Card';
import Row, { TableDetailsBody } from '../../elements/common/TableDetailsRow';
import { PERMISSION } from '../../helpers/Permissions';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';

export default function NotificationDetails() {
    const { id } = useNumberParams();
    const [notification, setNotification] = useState<ManualNotification>({} as any);

    useOnce(() => CRMApi.manualNotifications.getById(id).then(setNotification));

    return (
        <Card title="Notification details">
            <TableDetailsBody>
                <Row label="ID">{notification.id}</Row>
                <Row label="Admin ID">
                    <ProtectedLink
                        url={`/admins/${notification.admin_id}`}
                        value={notification.admin_id}
                        permissions={[PERMISSION.VIEW_ADMIN]}
                    />
                </Row>
                <Row label="Title">{notification.title}</Row>
                <Row label="Content">
                    <Editor id="text" init={{ height: 400 }} value={notification.content} disabled />
                </Row>
                <Row label="Is Active">
                    <TrueFalseIcon status={notification.is_active} />
                </Row>
                <Row label="Start date">{notification.start_date}</Row>
                <Row label="Cycle">{notification.cycle}</Row>
                {notification.cycle_days?.length > 0 ? (
                    <Row label="Cycle days">{notification.cycle_days?.join(', ')}</Row>
                ) : null}
                <Row label="Deliver time">{notification.deliver_time}</Row>
                {notification.left_to_deliver > 0 ? (
                    <Row label="Left to deliver">{notification.left_to_deliver}</Row>
                ) : (
                    <Row label="End date">{notification.end_date}</Row>
                )}
            </TableDetailsBody>
            <Link to={`/notifications/${id}/update`} className="btn btn-default right">
                Edit Notification
            </Link>
        </Card>
    );
}
